import { Button } from 'react-bootstrap';
import styles from './MemberNav.module.scss';
import { ReactComponent as OutlinePlus16 } from 'assets/svg/outline-plus-16.svg';
import MoreActionsDropdown from '../../utils/MoreActionsDropdown';
// import { ReactComponent as MagnifyingGlass } from 'assets/svg/magnifying-glass.svg';

const MemberNav = ({
  memberCount,
  practiceSchedulerCount,
  searchParam,
  setSearchParam,
  setShowAddMemberModal,
  setShowAddRolesModal,
}) => {
  const getDropdownActions = () => {
    return [
      {
        label: 'Manage Role',
        actionLabel: 'EDIT_ACTION',
        onClick: () => {
         setShowAddRolesModal(true);
        },
        className: '',
      },
    ];
  };

  return (
    <>
      <div className={styles['member_nav__team']}>Team</div>
      <div className={styles['member_nav__container']}>
        <div className={styles['member_nav__search-container']}>
          <div>
            <span className='mr-3'>Member</span>
            <span>{memberCount}</span>
          </div>
          <div>
            <MoreActionsDropdown actions={getDropdownActions()} member={null} />
          </div>
          <div className='input-group'>
            {/* <span
              className={`${styles['member_nav__input-group-search']} input-group-text bg-white border-end-0`}
            >
              <MagnifyingGlass />
            </span> */}
            {/* <input
              type='search'
              className={`form-control ${styles['member_nav__form-control-search']}`}
              title='Search Members'
              value={searchParam}
              onChange={e => setSearchParam(e.target.value)}
              placeholder='Search members...'
            /> */}
          </div>
        </div>
        <Button
          className={styles['member_nav__create-new-button']}
          disabled={practiceSchedulerCount >= 1}
          onClick={() => {
            setShowAddMemberModal(true);
          }}
        >
          <OutlinePlus16 className='mr-3' />
          Add
        </Button>
      </div>
    </>
  );
};

export default MemberNav;
